import { Trans } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

const Description = styled.p`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  font-size: 24px;
  line-height: 33px;
  letter-spacing: -0.2px;
  font-weight: 600;
  text-align: center;
  max-width: 920px;
  margin: 0;
  color: ${colors.regular};

  :not(:last-child) {
    margin-bottom: 30px;
  }

  a {
    text-decoration: underline;
    color: ${colors.regular};
  }

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    width: 85vw;
    font-size: 21px;
    line-height: 29px;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 18px;
    text-align: left;
    line-height: 24px;
  }
`

const Underline = styled.span``

const OurMission = () => (
  <>
    <Description>
      <Trans i18nKey="about:description_1">
        liv.rent was created with two main goals in mind: building a trusted
        rental community to improve tenant-landlord relationships and creating a
        platform to eliminate the stress and uncertainty of renting. Through our
        platform and channels, we hope to help our community navigate through
        the rental process.
      </Trans>
    </Description>
    <Description>
      <Trans i18nKey="about:description_2">
        Equipped with all the features you need to rent successfully, liv.rent
        allows both renters and landlords to complete the entire rental process
        all in one place.{' '}
        <a href="https://liv.rent/blog/2020/06/how-to-become-verified/">
          <Underline>Verified listings</Underline>
        </a>
        , digital applications & contracts, as well as our secure digital filing
        cabinet, make renting easy and secure for you.{' '}
      </Trans>
    </Description>
  </>
)

export default OurMission
